module.exports = __webpack_public_path__ + "img/bus.01221e23.png";